function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPapers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.9375 4.101562 L 10.9375 7.03125 L 5.078125 7.03125 L 5.078125 48.828125 L 39.0625 48.828125 L 39.0625 42.96875 L 44.921875 42.96875 L 44.921875 1.171875 L 10.9375 1.171875 Z M 42.96875 22.070312 L 42.96875 41.015625 L 39.0625 41.015625 L 39.0625 14.648438 L 31.445312 7.03125 L 12.890625 7.03125 L 12.890625 3.125 L 42.96875 3.125 Z M 30.078125 12.5 L 30.078125 16.015625 L 37.109375 16.015625 L 37.109375 46.875 L 7.03125 46.875 L 7.03125 8.984375 L 30.078125 8.984375 Z M 35.546875 13.945312 C 35.546875 14.023438 34.765625 14.0625 33.789062 14.0625 L 32.03125 14.0625 L 32.03125 10.390625 L 33.789062 12.109375 C 34.765625 13.046875 35.546875 13.867188 35.546875 13.945312 Z M 35.546875 13.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 17.96875 15.039062 L 17.96875 16.015625 L 26.171875 16.015625 L 26.171875 14.0625 L 17.96875 14.0625 Z M 17.96875 15.039062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.9375 20.898438 L 10.9375 21.875 L 32.8125 21.875 L 32.8125 19.921875 L 10.9375 19.921875 Z M 10.9375 20.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.9375 27.148438 L 10.9375 28.125 L 32.8125 28.125 L 32.8125 26.171875 L 10.9375 26.171875 Z M 10.9375 27.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.9375 33.007812 L 10.9375 33.984375 L 32.8125 33.984375 L 32.8125 32.03125 L 10.9375 32.03125 Z M 10.9375 33.007812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.015625 40.898438 L 11.132812 41.992188 L 15.546875 42.109375 L 19.921875 42.226562 L 19.921875 39.84375 L 10.898438 39.84375 Z M 11.015625 40.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 23.984375 40.429688 C 23.398438 41.953125 24.023438 42.1875 28.515625 42.1875 L 32.8125 42.1875 L 32.8125 39.84375 L 28.515625 39.84375 C 25.039062 39.84375 24.140625 39.960938 23.984375 40.429688 Z M 23.984375 40.429688 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapers);
export default __webpack_public_path__ + "static/media/papers.f84918e19a1266959deec1bb07b59984.svg";
export { ForwardRef as ReactComponent };